export var IosAlertStyle;
(function (IosAlertStyle) {
    IosAlertStyle[IosAlertStyle["NONE"] = 0] = "NONE";
    IosAlertStyle[IosAlertStyle["BANNER"] = 1] = "BANNER";
    IosAlertStyle[IosAlertStyle["ALERT"] = 2] = "ALERT";
})(IosAlertStyle || (IosAlertStyle = {}));
export var IosAllowsPreviews;
(function (IosAllowsPreviews) {
    IosAllowsPreviews[IosAllowsPreviews["NEVER"] = 0] = "NEVER";
    IosAllowsPreviews[IosAllowsPreviews["ALWAYS"] = 1] = "ALWAYS";
    IosAllowsPreviews[IosAllowsPreviews["WHEN_AUTHENTICATED"] = 2] = "WHEN_AUTHENTICATED";
})(IosAllowsPreviews || (IosAllowsPreviews = {}));
export var IosAuthorizationStatus;
(function (IosAuthorizationStatus) {
    IosAuthorizationStatus[IosAuthorizationStatus["NOT_DETERMINED"] = 0] = "NOT_DETERMINED";
    IosAuthorizationStatus[IosAuthorizationStatus["DENIED"] = 1] = "DENIED";
    IosAuthorizationStatus[IosAuthorizationStatus["AUTHORIZED"] = 2] = "AUTHORIZED";
    IosAuthorizationStatus[IosAuthorizationStatus["PROVISIONAL"] = 3] = "PROVISIONAL";
    IosAuthorizationStatus[IosAuthorizationStatus["EPHEMERAL"] = 4] = "EPHEMERAL";
})(IosAuthorizationStatus || (IosAuthorizationStatus = {}));
//# sourceMappingURL=NotificationPermissions.types.js.map